import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export const CustomRadioGroup = ({
  name,
  // eslint-disable-next-line no-unused-vars
  value,
  options,
  setFieldValue,
  disabled,
  onChange,
  ...props
}) => {
  const handleChange = (event, res) => {
    if (setFieldValue) {
      setFieldValue(name, res);
    }
    onChange && onChange(res);
  };

  return (
    <RadioGroup row name={name} onChange={handleChange} value={value} {...props}>
      {options?.map(({ value, label }) => (
        <FormControlLabel
          key={value}
          disabled={disabled}
          value={value}
          control={<Radio />}
          label={label}
        />
      ))}
    </RadioGroup>
  );
};

CustomRadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

CustomRadioGroup.defaultProps = {
  onChange: () => {}
};
